export default __webpack_public_path__ + "static/media/expense-management.5d913242.png";